// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HM4A","footer":"styles_footer__291to","passCodeTooltip":"styles_passCodeTooltip__1MkSg"};